<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/04_Aspromonte/04_2_Canolo-Gerace-Gambarie/04_2_Gerace-Castello.jpg">
<div class="content">
    <h1>Aspromonte</h1>
    <h3>Gerace</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale dell’Aspromonte</a> > <a class="active">Gerace</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Canolo-Gerace-Gambarie d’Aspromonte</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/04_Aspromonte/04_2_Canolo-Gerace-Gambarie/04_2_Gerace-Castello.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            L’itinerario è immerso nel magnifico paesaggio dell’Aspromonte che, a dispetto del nome, offre una natura straripante che a 
            tratti evoca atmosfere fiabesche per i grandi massi affioranti, le faggete e le pinete in cui si pedala in solitudine per ore, 
            in totale armonia con la natura. 
            <br>
            <br>
            La prima tappa muove da Canolo per raggiungere in 16 Km uno dei centri storici più belli del nostro Paese, Gerace, 
            la città normanna delle “cento chiese” che domina la locride con l’antica Locri Epizefiri, influente città della Magna Grecia fondata nel VII secolo a.C.             
            <br>
            <br>
            Edward Lear scrisse di Gerace che «ogni roccia, santuario e palazzo sembra colorato e fatto apposta per gli artisti e 
            l’unione delle linee realizzate dalla natura e dall’arte è semplicemente deliziosa». E il modo migliore per conoscere Gerace, 
            “eccellenza da vivere” inserita tra i Borghi accoglienti del Touring Club, è quello di percorrerla a piedi, passeggiando tra i diversi rioni, 
            le sue Chiese - documenti attestano che in passato se ne contassero cento -, il Museo Civico con i reperti archeologici dell’Area Stefanelli, 
            anche punto informativo e Centro visita del Parco dell’Aspromonte, i Palazzi storici, le installazioni d’arte contemporanea. E poi, dulcis in fundo, 
            i laboratori e le botteghe artigiane, un vero e proprio tesoro di tradizioni e saperi, in cui spiccano la produzione di ceramica e quella dei tessuti; 
            imperdibili i gelati, le granite e le “rafiole”.
            <br>
            <br>
            La seconda tappa, invece, procede da Gerace verso Gambarie attraversando uno dei tratti più belli del Parco dell’Aspromonte 
            che corre sullo Zomaro e i Piani dello Zilastro (1061 m) per poi risalire in quota verso Zervò; attraversa il crinale sulla Valle delle 
            grandi pietre (1250 m) e approda a Gambarie d’Aspromonte (1320 m), non prima di aver incrociato il “cippo” e il Mausoleo di Garibladi. 
            Gambarie è una storica stazione sciistica; è qui, infatti, che nel 1956 è stata costruita la prima seggiovia del meridione, 
            la stessa che oggi dispone di diversi impianti di risalita con partenza dal centro abitato. Si tratta di 30 chilometri di piste 
            battute con vari livelli di difficoltà che attraversano foreste di pini, abeti e faggi, offrendo agli appassionati di sci alpino e 
            snowboard un’esperienza unica, anche per il magnifico orizzonte sullo Stretto che si gode dalle vette. A Gambarie ha sede l’Ente Parco 
            Nazionale dell’Aspromonte e, a pochi chilometri, in località Cucullaro, si trova l’Osservatorio per la biodiversità, dove è possibile approfondire 
            la conoscenza di flora, fauna, habitat ed ecosistemi della Calabria e del Parco Nazionale dell’Aspromonte. 
            Il “bosco delle fate” offre itinerari magnifici percorribili a piedi partendo dal centro abitato.           
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>84 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>2490 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>2050 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Canolo Nuova</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Gambarie d’Aspromonte</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-10 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
